import ErpInventoryList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/inventories") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpInventoryList();
    }
}